export const SET_LOCALE = "SET_LOCALE"
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE"
export const SET_NAVIGATION_DRAWER = "SET_NAVIGATION_DRAWER"
export const SET_VIEW = "SET_VIEW"
export const SET_DIALOG_LOCATION = "SET_DIALOG_LOCATION"